var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ThesaurusModel {
    communityId;
    id;
    isCandidate;
    name;
    countryId;
    description;
    stockageId;
}
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", String)
], ThesaurusModel.prototype, "communityId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ThesaurusModel.prototype, "id", void 0);
__decorate([
    Expose({ name: 'is_candidate' }),
    __metadata("design:type", String)
], ThesaurusModel.prototype, "isCandidate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ThesaurusModel.prototype, "name", void 0);
__decorate([
    Expose({ name: 'country_id' }),
    __metadata("design:type", Object)
], ThesaurusModel.prototype, "countryId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ThesaurusModel.prototype, "description", void 0);
__decorate([
    Expose({ name: 'stockage_id' }),
    __metadata("design:type", Object)
], ThesaurusModel.prototype, "stockageId", void 0);
